// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"userAvatar_avatarWrapper__RQri6","personAvatar":"userAvatar_personAvatar__D+bs8"};